import React from "react";
import { FormattedMessage } from "react-intl";
import {
  type ISelectInputProps,
  SelectInput,
  type SelectInputType,
} from "src/shared/forms/inputs/SelectInput";
import { useGetLanguageName } from "src/shared/languages/useGetLanguageName";
import type { Language } from "src/shared/objects/Language";

export interface ILanguageInputProps
  extends Omit<ISelectInputProps, "label" | "children"> {
  languages: Language[];
  SelectComponent?: SelectInputType;
}

export const LanguageInput = ({
  languages,
  SelectComponent = SelectInput,
  ...rest
}: ILanguageInputProps) => {
  const getLanguageName = useGetLanguageName();
  return (
    <SelectComponent
      label={<FormattedMessage id="contacts.language" />}
      {...rest}
    >
      {languages.map((language) => (
        <option key={language.languageCode} value={language.languageCode}>
          {getLanguageName(language)}
        </option>
      ))}
    </SelectComponent>
  );
};
